import { render, staticRenderFns } from "./DispatchManager.vue?vue&type=template&id=5d9e209c&scoped=true&"
import script from "./DispatchManager.vue?vue&type=script&lang=ts&"
export * from "./DispatchManager.vue?vue&type=script&lang=ts&"
import style0 from "./DispatchManager.vue?vue&type=style&index=0&id=5d9e209c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e209c",
  null
  
)

export default component.exports